export default __webpack_public_path__ + "static/media/mixnsave.b9ed2d3e.png";